import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

ErrorMonitoringService.init();
